import React from "react";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    games: {
        width: 34,
        marginRight: 5,
        marginTop: 6
    }
});

export default function Games() {
    const classes = useStyles();
    return <img src="/assets/images/new_icons/games.svg" className={classes.games} alt="Games" />
}
